import { render, staticRenderFns } from "./r-treasure-level-config-dialog.vue?vue&type=template&id=1b7f1fe4&scoped=true"
import script from "./r-treasure-level-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-treasure-level-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-treasure-level-config-dialog.vue?vue&type=style&index=0&id=1b7f1fe4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f1fe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7f1fe4')) {
      api.createRecord('1b7f1fe4', component.options)
    } else {
      api.reload('1b7f1fe4', component.options)
    }
    module.hot.accept("./r-treasure-level-config-dialog.vue?vue&type=template&id=1b7f1fe4&scoped=true", function () {
      api.rerender('1b7f1fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-treasure/r-treasure-level-config-dialog.vue"
export default component.exports